import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { GetLanguageResponse } from "@/types/language";

import { getLanguages } from "./languageApi";

type LanguageOption = {
  label: string;
  value: string;
};

export const useGetLanguages = (
  options?: Omit<
    UseQueryOptions<GetLanguageResponse[], Error, LanguageOption[]>,
    "queryKey" | "queryFn" | "select"
  >
) => {
  return useQuery<GetLanguageResponse[], Error, LanguageOption[]>({
    queryKey: ["languages"],
    queryFn: () => getLanguages(),
    select: (langs) => {
      const mapped = (langs ?? []).map((lng) => ({
        label: lng.name,
        value: lng.code
      }));

      return mapped.length > 0
        ? mapped
        : [{ label: "English", value: "en-US" }];
    },
    ...(options || {})
  });
};
